import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './Login.css';
import logoImage from '../img/citylink_logo.webp';
import { API_BASE } from '../config/apiConfig';

const AdminRegister = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      alert('Please enter both email and password');
      return;
    }
    if (password.length < 6) {
      alert('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE}/auth/register`, {
        email,
        password,
        fullName: fullName || undefined,
        role: 'admin'
      });

      if (response.data.success) {
        alert('Admin account created. Please sign in with your credentials.');
        navigate('/login');
      }
    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'Registration failed';
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <span className="login-logo-mark">
              <img src={logoImage} alt="CityLink logo" className="login-logo-img" />
            </span>
            <span className="login-logo-text">
              <span className="login-logo-city">CITY</span>
              <span className="login-logo-link">LINK</span>
            </span>
          </div>
          <h1>Admin Sign Up</h1>
          <p>Create an account for government staff to manage permits in your county</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fullName">Full name (optional)</label>
            <input
              id="fullName"
              type="text"
              placeholder="Your full name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              autoComplete="name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="your@email.gov"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="At least 6 characters"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
            />
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Creating...' : 'Create admin account'}
          </button>
        </form>

        <div className="form-footer" style={{ marginTop: 20, textAlign: 'center' }}>
          <p>Already have an admin account? <Link to="/login">Sign in</Link></p>
          <p><Link to="/">← Back to home</Link></p>
        </div>
      </div>
    </div>
  );
};

export default AdminRegister;
